import { render, staticRenderFns } from "./CustomFlexHeader.vue?vue&type=template&id=4cbfd8fb&scoped=true"
import script from "./CustomFlexHeader.vue?vue&type=script&lang=js"
export * from "./CustomFlexHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomFlexHeader.vue?vue&type=style&index=0&id=4cbfd8fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbfd8fb",
  null
  
)

export default component.exports